export const fmtMoney = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n || 0);

export function JobValueTag({ job, size = "xs" }) {
  if (!job?.job_value) return null;
  const cls = size === "sm" ? "text-xs px-2 py-0.5" : "text-[10px] px-1.5 py-0.5";
  const paid = job.job_value_source === "invoice";
  return (
    <span
      data-testid={`job-value-${job.job_id}`}
      title={paid ? "Invoice total" : "Quote total (incl. tax)"}
      className={`inline-flex items-center rounded font-bold whitespace-nowrap ${cls} ${paid ? "bg-emerald-600 text-white" : "bg-emerald-50 text-emerald-800 border border-emerald-200"}`}
    >
      {fmtMoney(job.job_value)}
    </span>
  );
}

export function RevenueBanner({ label, screens, completedScreens, value, earned, testid }) {
  if (!screens && !value) return null;
  return (
    <div className="mb-4 p-3 bg-[#207024]/10 rounded-lg border border-[#207024]/20 flex flex-wrap items-center gap-x-6 gap-y-1" data-testid={testid}>
      {value > 0 && (
        <p className="font-inter text-sm font-semibold text-[#207024]">
          {label} Revenue: <span className="text-base font-bold" data-testid={`${testid}-value`}>{fmtMoney(value)}</span>
          {earned > 0 && <span className="ml-1.5 text-xs font-medium text-zinc-500 whitespace-nowrap">({fmtMoney(earned)} done)</span>}
        </p>
      )}
      {screens > 0 && (
        <p className="font-inter text-sm font-semibold text-[#207024]">
          {label} Total: {screens} screens
          {completedScreens > 0 && <span className="ml-1.5 text-xs font-medium text-zinc-500 whitespace-nowrap">({completedScreens} done)</span>}
        </p>
      )}
    </div>
  );
}
